import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { providePrimeNG } from './infrastructure/configs/primeng.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './infrastructure/authentication/auth.interceptor';
import { provideApi } from '@app/infrastructure/configs/api.config';
import { ConfirmationService, FilterService, MessageService } from 'primeng/api';
import { provideDatePipeFormat } from '@app/infrastructure/configs/date-pipe.config';
import { provideNgxs } from '@app/infrastructure/configs/ngxs.config';
import { serverErrorMessageInterceptor } from '@app/infrastructure/errors/interceptors';
import { CrossTabLogoutService } from './shared/common/services/cross-tab-logout-service';
import { PageTitleStrategy } from '@app/infrastructure/routing/page-title.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: PageTitleStrategy },
    provideHttpClient(withInterceptors([authInterceptor, serverErrorMessageInterceptor])),
    provideApi(),

    // This deprecated usage will be removed when PrimeNG is upgraded to v21
    provideAnimationsAsync(),
    providePrimeNG(),
    provideDatePipeFormat(),
    provideNgxs(),
    provideAppInitializer(() => inject(CrossTabLogoutService).init()),
    provideAppInitializer(() => {
      const filterService = inject(FilterService);
      const contains = filterService.filters['contains'];
      filterService.register(
        'trimContains',
        (value: unknown, filter: unknown, filterLocale?: string) =>
          contains(value, typeof filter === 'string' ? filter.trim() : filter, filterLocale),
      );
    }),
    ConfirmationService,
    MessageService,
  ],
};
